<template>
<!-- Not a router link to reload ads -->
  <a class="exit" href="/" :style="transparentColor">
    <div class="text">Exit</div>
    <div class="icon">
      <IconBase
        icon-name="exit"
        iconColor="#2d2d2d"
        viewBox="0 0 512.016 512"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><IconLeave
      /></IconBase>
    </div>
  </a>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconLeave from "../../../../components/SVG/IconLeave";

import { transparentColor } from "../SessionHelpers/colors";

export default {
  name: "ExitButton",
  components: {
    IconBase,
    IconLeave,
  },
  computed: {
    transparentColor() {
      return transparentColor();
    },
  },
};
</script>